import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectPetsAllowed = createSelector(selectJsonQuery, jsonQuery => getTermValue('pets')(jsonQuery));
